export default __webpack_public_path__ + "static/media/FiveX_loading_dye.0c726db1.svg";